import React, {useState} from 'react';

import { useDarkMode } from 'context/DarkModeContext';

import Icon from 'components/Icon';
import Dim from 'components/Dim';
import useLayout from 'hooks/useLayout';
import { useSearchParams } from 'react-router-dom';

const FloatingNav = ({ isShuffled, setIsShuffled }) => {
  const { toggleDarkMode } = useDarkMode();
  const [searchParams, setSearchParams] = useSearchParams();

  const { view, gridColumns, setGridColumns, isSearchOpen, openSearch, closeSearch } = useLayout();

  const [isRangeInputOpen, setIsRangeInputOpen] = useState(false);

  const handleShuffleProducts = () => {
    setIsShuffled(prev => !prev);
  };

  const handleToggleRangeInput = () => {
    setIsRangeInputOpen(prev => !prev);
  };

  /** Grid 사이즈 조절 함수 */
  const handleInputChange = event => {
    let value = parseInt(event.target.value, 10);
    setGridColumns(value);
  };

  const handleSearchInputChange = event => {
    const target = event.target.value;
    setSearchParams({ search: target });
  };

  const toggleSearch = () => {
    isSearchOpen ? closeSearch() : openSearch();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur(); // 포커스 제거
    }
  };

  return (
    <div className={'floating-bar'}>
      <div className={'floating-bar__menu'}>
        <button onClick={toggleSearch}>
          <Icon icon={'Search'} />
        </button>
        {!isSearchOpen && (
          <>
            <button onClick={() => toggleDarkMode()}>
              <Icon icon={'Brightness'} />
            </button>
            {view === 'IMAGE' && searchParams.get('sort') === null && (
              <button onClick={handleShuffleProducts}>
                <Icon icon={isShuffled ? 'Shuffle_back' : 'Shuffle'} />
              </button>
            )}
            {view === 'IMAGE' && (
              <div className={'scale'}>
                {!isRangeInputOpen && (
                  <button onClick={handleToggleRangeInput}>
                    <Icon icon={'Scale'} />
                  </button>
                )}
                {isRangeInputOpen && view === 'IMAGE' && (
                  <div className={'range'}>
                    <button onClick={handleToggleRangeInput}>
                      <Icon icon={'Close'} />
                    </button>
                    <div className={'range-input'}>
                      <input type='range' min={0} max={2} step={1} value={gridColumns} onChange={handleInputChange} />
                      <div className={'thumb'} style={{ left: gridColumns * 57 }}></div>
                      <div className={'line'}></div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {isSearchOpen && (
          <form className={'search-container'}>
            <input
              onChange={handleSearchInputChange}
              className={'search-input'}
              onKeyDown={handleKeyDown}
              value={searchParams.get('search') || ''}
              placeholder={'SEARCH...'}
                // autoFocus
            />
            <button
              onClick={() => {
                closeSearch();
                searchParams.delete('search');
                setSearchParams(searchParams);
              }}
            >
              <Icon icon={'Close'} />
            </button>
          </form>
        )}
      </div>
      <div id={'safe-area'}></div>
      {isRangeInputOpen && <Dim onClick={() => setIsRangeInputOpen(false)} />}
    </div>
  );
};

export default FloatingNav;
